













import Vue from 'vue';
import { mapState } from 'vuex';
import {
  Component,
} from 'vue-property-decorator';

@Component({ computed: mapState(['lastUpdatedDate']) })
export default class DisclaimerFooter extends Vue {
    lastUpdatedDate!: string;
}
